/**
 * Computes a `hitSlop` value that expands the touchable region of a
 * Pressable / IconButton until it meets the 44pt floor required by
 * ADR-0026 and WCAG 2.5.5 (Target Size). Pass the *visual* size of the
 * interactive surface in pixels; the returned object widens the touch
 * area symmetrically so the total target is `>= 44pt`.
 *
 * Example: a 24pt icon button needs `(44 - 24) / 2 = 10pt` of slop on
 * each side. A 44pt button needs none.
 *
 * Not a React hook in the React lifecycle sense — named with `use*` to
 * match the existing convention in `libs/ui/src/hooks/` and the wider
 * codebase. Pure computation; no state.
 */
export const MIN_HIT_TARGET = 44;

export function useHitSlop(visualSize: number, minTarget: number = MIN_HIT_TARGET): {
  top: number; right: number; bottom: number; left: number;
} {
  const slop = Math.max(0, Math.ceil((minTarget - visualSize) / 2));
  return { top: slop, right: slop, bottom: slop, left: slop };
}
